import { render } from "./settings-user.vue?vue&type=template&id=5778e0fe"
import script from "./settings-user.vue?vue&type=script&lang=js"
export * from "./settings-user.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__